import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { FormTypeBuilder } from '@shared/models/formTypeBuilder';
import { UserRegisterDTO } from '../../models';
import { RegisterFormType } from './register.component.types';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  public registerForm: FormGroup<FormTypeBuilder<RegisterFormType>>;
  public registerSuccess = false;
  public loading = false;

  constructor(private fb: NonNullableFormBuilder, private auth: AuthService) {
    this.registerForm = this.fb.group<FormTypeBuilder<RegisterFormType>>({
      Bulstat: new FormControl('', Validators.required),
      Email: new FormControl('test@mail.bg', [Validators.required, Validators.email]),
      ControlNumber: new FormControl('1234567890', Validators.required),
      Recaptcha: new FormControl('', Validators.required),
      Password: new FormControl('1234', Validators.required),
    });
  }

  public submit() {
    this.loading = true;
    if (this.registerForm.valid) {
      this.auth
        .register(this.registerForm.value as UserRegisterDTO)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe((res) => (this.registerSuccess = true));
    }
  }

  ngOnInit(): void {}
}
